export default __webpack_public_path__ + "static/media/lemon-tree.f614c20f.svg";